let toggleSwitch = null;

/**
 * Initializes theme system
 * Check for saved theme preference or system preference
 */
export const initTheme = () => {
  toggleSwitch = document.getElementById("toggle-switch-mode");

  // Check local storage for saved preference
  const savedTheme = localStorage.getItem("theme");

  if (savedTheme) {
    // Use saved preference
    applyTheme(savedTheme);
  } else {
    // Check system preference
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)",
    ).matches;
    applyTheme(prefersDark ? "dark" : "light");
  }

  // Listen for toggle clicks
  toggleSwitch.addEventListener("change", handleThemeToggle);
};

/**
 * Applies the theme to the document
 * @param {string} theme - "light" or "dark
 */
const applyTheme = (theme) => {
  const html = document.documentElement;

  if (theme === "dark") {
    html.classList.add("dark");
  } else {
    html.classList.remove("dark");
  }

  // Save preference
  localStorage.setItem("theme", theme);

  // Update checkbox state
  if (toggleSwitch) {
    toggleSwitch.checked = theme === "dark";
  }
};

/**
 * Handles theme toggle switch change
 * @param {*} event
 */
const handleThemeToggle = (event) => {
  const theme = event.target.checked ? "dark" : "light";
  applyTheme(theme);
};

/**
 * Gets current theme
 * @returns {string} 'light' or 'dark'
 */
export const currentTheme = () => {
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
};
